module.exports = __webpack_public_path__ + "static/media/hamdy_mubarak_3.7e2b09a0.jpeg";